import { Status } from "../design/Hinweis";
import { useVersionshinweis } from "./lebenszyklus";

/**
 * Hinweis des Lebenszyklus über jeder Ansicht (oberflaeche.md §9, V-27): „Neue Version geladen.“ nach dem Wechsel,
 * „Neue Version wird geladen.“, wenn die App zu alt ist. Er verdeckt nichts Bedienbares (keine Zeigerereignisse).
 */
export function Versionshinweis() {
  const text = useVersionshinweis();
  if (!text) return null;
  return <div className="versionshinweis"><Status symbol="info">{text}</Status></div>;
}
